import React from 'react';
import { MemoryRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Demo from './pages/Demo';
import JoinUs from './pages/JoinUs';
import Tuzuk from './pages/Tuzuk';
import YonetimKurulu from './pages/YonetimKurulu';
import YarismaTakvimi from './pages/YarismaTakvimi';


const ScrollHandler = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  // Handle page reload -> redirect to home
  React.useEffect(() => {
    // Force browser URL to be just the domain
    if (window.location.pathname !== '/') {
      window.history.replaceState(null, '', '/');
    }

    const navEntries = window.performance?.getEntriesByType('navigation');
    if (navEntries && navEntries.length > 0) {
      const navType = (navEntries[0] as PerformanceNavigationTiming).type;
      if (navType === 'reload') {
        if (pathname !== '/') {
          navigate('/', { replace: true });
        }
        window.scrollTo(0, 0);
      }
    }
  }, []);

  // Handle scroll to top or anchor on route change
  React.useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 400);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const Layout = () => {
  const location = useLocation();
  const isDemo = location.pathname === '/demo';

  return (
    <div className="App relative min-h-screen">
      <ScrollHandler />
      <div className="relative z-10 flex flex-col min-h-screen">
        {!isDemo && <Navbar />}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/nasil-katilabilirsiniz" element={<JoinUs />} />
            <Route path="/tuzugumuz" element={<Tuzuk />} />
            <Route path="/yonetim-kurulumuz" element={<YonetimKurulu />} />
            <Route path="/yarisma-takvimi" element={<YarismaTakvimi />} />
            <Route path="/demo" element={<Demo />} />
            {/* All routes from Stitch project screens integrated */}
          </Routes>
        </main>
        {!isDemo && <Footer />}
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
